module.exports = __webpack_public_path__ + "static/media/icon_x.4fee60d1.svg";